export default class DeferredUploadAdapter {
    constructor(loader, pendingUploads) {
        this.loader = loader
        this.pendingUploads = pendingUploads
    }

    upload() {
        return this.loader.file.then(file => {
            const blobUrl = URL.createObjectURL(file)
            this.pendingUploads.set(blobUrl, file)
            return { default: blobUrl }
        })
    }

    abort() {
    }
}
